<form [formGroup]="baseFormGroup" #f="ngForm" class="mt-4 pl-2 form-horizontal">
  <div class="form-group row">
    <div class="col-md-12">
      <yt-input
       [Type]="'text'"
        [Label]="'SPREMA.SIFRA.SINGULAR'" name="txtSifra" #autofocus autocomplete="off"
        formControlName="Sifra" [ngClass]="{'is-invalid': submitted && fc.Sifra.invalid}">
      </yt-input>
      <div class="form-error" *ngIf="submitted && fc.Sifra.invalid">
        <span *ngFor="let validation of errorMessages.Sifra">
          <span class="error-message" *ngIf="fc.Sifra.hasError(validation.type)"><span translate="{{validation.message}}"></span></span>
        </span>
      </div>
    </div>
  </div>
  <div class="form-group row">
    <div class="col-md-12">
      <yt-input [Type]="'text'" [Label]="'SPREMA.NAZIV.SINGULAR'" name="txtNaziv" autocomplete="off" formControlName="Naziv"
        [ngClass]="{'is-invalid': submitted && fc.Naziv.invalid}">
      </yt-input>
      <div class="form-error" *ngIf="submitted && fc.Naziv.invalid">
        <span *ngFor="let validation of errorMessages.Naziv">
          <span class="error-message" *ngIf="fc.Naziv.hasError(validation.type)"><span translate="{{validation.message}}"></span></span>
        </span>
      </div>
    </div>
  </div>
  <div class="form-group row">
    <div class="col-md-12">
      <yt-input [Type]="'text'" [Label]="'SPREMA.NIVO.SINGULAR'" name="txtNivo" autocomplete="off" formControlName="Nivo"
        [ngClass]="{'is-invalid': submitted && fc.Nivo.invalid}">
      </yt-input>
      <div class="form-error" *ngIf="submitted && fc.Nivo.invalid">
        <span *ngFor="let validation of errorMessages.Nivo">
          <span class="error-message" *ngIf="fc.Nivo.hasError(validation.type)"><span translate="{{validation.message}}"></span></span>
        </span>
      </div>
    </div>
  </div>
  <div class="form-group row">
    <div class="col-md-12">
      <yt-input [Type]="'text'" [Label]="'SPREMA.OPIS.SINGULAR'" name="txtOpis" autocomplete="off" formControlName="Opis"
        [ngClass]="{'is-invalid': submitted && fc.Opis.invalid}">
      </yt-input>
      <div class="form-error" *ngIf="submitted && fc.Opis.invalid">
        <span *ngFor="let validation of errorMessages.Opis">
          <span class="error-message" *ngIf="fc.Opis.hasError(validation.type)"><span translate="{{validation.message}}"></span></span>
        </span>
      </div>
    </div>
  </div>
  <div class="form-group row">
    <div class="col-md-12">
      <yt-input [Type]="'text'" [Label]="'SPREMA.EKVIVALENCIJA.SINGULAR'" name="txtEkvivalencija" autocomplete="off"
        formControlName="Ekvivalencija" [ngClass]="{'is-invalid': submitted && fc.Ekvivalencija.invalid}">
      </yt-input>
      <div class="form-error" *ngIf="submitted && fc.Ekvivalencija.invalid">
        <span *ngFor="let validation of errorMessages.Ekvivalencija">
          <span class="error-message" *ngIf="fc.Ekvivalencija.hasError(validation.type)"><span translate="{{validation.message}}"></span></span>
        </span>
      </div>
    </div>
  </div>
</form>